document.querySelectorAll<HTMLElement>('.otp-input').forEach(container => {
    const inputs = container.querySelectorAll(
        'input[type="text"]'
    ) as NodeListOf<HTMLInputElement>;
    const hidden_input = container.querySelector(
        'input[type="hidden"]'
    ) as HTMLInputElement;
    const length = 6;

    function update_otp_value() {
        let value = '';
        inputs.forEach(input => {
            value += input.value;
        });

        hidden_input.value = value;
    }

    inputs.forEach((input, index) => {
        input.addEventListener('input', () => {
            if (input.value && index < length - 1) {
                inputs[index + 1].focus();
            }
            update_otp_value();
        });

        input.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Backspace') {
                if (!input.value && index > 0) {
                    inputs[index - 1].focus();
                }
            } else if (event.key === 'ArrowLeft' && index > 0) {
                inputs[index - 1].focus();
            } else if (event.key === 'ArrowRight' && index < length - 1) {
                inputs[index + 1].focus();
            }
        });
    });

    container.addEventListener('paste', (event: ClipboardEvent) => {
        event.preventDefault();
        const paste_data = (event as any).clipboardData.getData('text').trim();
        if (!/^\d+$/.test(paste_data)) return;

        const characters = paste_data.split('');
        characters.forEach((character: string, index: number) => {
            if (inputs[index]) {
                inputs[index].value = character;
            }
        });

        const next_index = Math.min(characters.length, length - 1);
        inputs[next_index].focus();
        update_otp_value();
    });
});
